import { Component, OnInit } from '@angular/core';

import {
    CommonComponent,
    CommonElementsConfig,
} from '../common/common.component';

@Component({
    selector: 'app-dialog-ledger-refund',
    templateUrl: '../common/common.component.html',
    styleUrls: ['../common/common.component.css'],
})
export class RefundComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig(['comment']);

    public override submitLabel = 'Refund';
    public override headingLabel = 'Refund Transaction';

    public override submit() {
        let payload = {
            transaction_id: Number(this.transactionModel!.id),
            comment: this.formGroup.get('comment')!.value,
        };

        this.sendPayload('ledger/refund', payload);
    }
}
